import { Component, Input } from '@angular/core'
import { ComunicadoModel } from '@shared/models/backend'

@Component({
  selector: 'app-comunicado',
  templateUrl: './comunicado.component.html',
  styleUrls: ['./comunicado.component.scss'],
})
export class ComunicadoComponent {
  @Input()
  comunicado: ComunicadoModel
}
